import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
// import {Md5} from 'ts-md5/dist/md5';
import { ElementRef, ViewChild, Inject } from '@angular/core';
import { DoctorService } from '../../services/doctor.service';

@Component({
  selector: 'app-proceedtochat',
  templateUrl: './proceedtochat.component.html',
  styleUrls: ['./proceedtochat.component.css']
})
export class ProceedtochatComponent implements OnInit {
  did: any;
  gateway: any;
  amt = 5000;
  chattype: any;
  securehash = '94d4cf9c067c4dd92a39b744b7c2748e';
  hashkey: any;
  loading: any;
  video: any;
  text: any;
  datas = [];
  fees2: any;
  fees1: any;
  serviceid2: any;
  serviceid1: any;
  @ViewChild('form') form: ElementRef;
  constructor(public dialogRef: MatDialogRef<ProceedtochatComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private doctorService: DoctorService ) {
    this.did = data.id;

  }

  ngOnInit() {
    this.getServices();
  }


  getServices(){
    this.loading = true;
    this.doctorService.getServices()
    .subscribe((x) => {
      for (let i = 0; i < x.length; i++) {
        if (x[i].name === 'Text Chat' ) {
          this.text = x[i].name;
          this.serviceid1 = x[i].id;
        }
        if (x[i].name === 'Video Chat') {
          this.video = x[i].name;
          this.serviceid2 = x[i].id;
        }
      }
      this.getServiceproviderId();
    });
  }
  getServiceproviderId() {
    this.doctorService.getServiceproviderId(this.did)
    .subscribe((x) => {
      this.getServicemenus(x[0].id);
    });
  }

  getServicemenus(spid) {
    this.doctorService.getServiceMenu(spid)
    .subscribe((x) => {
      for (let i = 0; i < x.length; i++) {
        if (x[i].service_id === this.serviceid1) {
          this.fees1 = x[i].fees;
          console.log(this.fees1);
        }

        if (x[i].service_id === this.serviceid2) {
          this.fees2 = x[i].fees;
          console.log(this.fees2);
        }
      }
      this.loading = false;
    });
  }

  goForChat() {
    const res = this.chattype;
    var fees;
    if (this.chattype === 'text') {
      fees = this.fees1;
      this.datas.push({'data1': res, 'data2': fees});
    } else {
      fees = this.fees2;
      this.datas.push({'data1': res, 'data2': fees});
    }
    this.dialogRef.close(this.datas);
  }



concat(data) {
  this.securehash = this.securehash.concat('|' + data);
}
/*
getHash() {
  console.log(this.securehash);
  this.hashkey = Md5.hashStr(this.securehash);
  console.log(this.hashkey);
  return this.hashkey;
} */
submitForm() {
  this.form.nativeElement.submit();
}
}
